import axios from 'axios';
import { LEADS_ENDPOINT } from 'cfgCommon/endpoints'
import {toast} from 'react-toastify';

export async function changeStateOpportunity(data){
    try{
        const res = await axios.put(`${LEADS_ENDPOINT}/changeStateOpportunity/${data.lead_id}`, data)
        return res
    }catch(error){
      toast.error(error.message)
    }
}